export default "__VITE_ASSET__BaaGIKYc__"